<i class="material-icons" (click)="btnClickedHandler($event)" >edit</i>